export class IMenuItem {
  Title: string;
  Url: string;

  ChildItems?: IMenuItem[];
}
